import { GET_MISSING, 
    GET_MISSING_SUCCESS,
    SHOW_Missing_MESSAGE,
    ON_SHOW_Missing_LOADER ,
    ON_HIDE_Missing_LOADER,
    HIDE_Missing_MESSAGE,
    ON_ADD_Missing,
    ON_ADD_Missing_Success} from "../../constants/ActionTypes";

export const getMissing = (pageIndex, searchText,justFind) => {
    return {
        type: GET_MISSING,
        payload: {
            pageIndex: pageIndex,
            searchText: searchText,
            justFind  : justFind
        }
    };
};
export const getMissingSuccess = (data) => {
    return {
        type: GET_MISSING_SUCCESS,
        payload: data,
    };
};

// export const showMissionLoader = () => {
//     return {
//       type: SHOW_Missing_MESSAGE,
//     };
//   };
  
  export const hideMissingMessage = () => {
    return {
      type: HIDE_Missing_MESSAGE,
    };
  };
  export const hideMissionLoader = () => {
    return {
      type: ON_HIDE_Missing_LOADER,
    };
  };
  
  export const showMissionMessage = (message) => {
    return {
      type: ON_SHOW_Missing_LOADER,
      payload: message
    };
  };
  
  export const AddMission = (mission) => {
    return {
      type: ON_ADD_Missing,
      payload: mission
    };
  };

  export const AddMissionSuccess = (missionId) => {
    return {
      type: ON_ADD_Missing_Success,
      payload: missionId
    };
  };